var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"incheon"},[_c('p',[_c('img',{staticClass:"incheonSugang",attrs:{"src":require("@/assets/img/incheon/incheon_seogu.jpg"),"usemap":"#Map"}}),_c('map',{attrs:{"name":"Map"}},[_c('area',{attrs:{"shape":"rect","coords":"149,562,788,683","href":"https://apply.carrotenglish.net/start?idx=1206","target":"_blank"}})])])])
}]

export { render, staticRenderFns }